module.exports = __webpack_public_path__ + "img/edit.ab932b69.svg";